/* eslint-disable */
export default function initFacebookSdk() {
  return new Promise((resolve, reject) => {
    if (document.getElementById('facebook-jssdk') !== null) {
      return resolve();
    }

    function statusChangeCallback(response) {
      if (response.status !== 'connected') {
        resolve();
      }
    }

    function scriptOnErroCallback(e) {
      document.getElementById('facebook-jssdk').remove();
      reject(e);
    }

    // wait for facebook sdk to initialize before starting the vue app
    window.fbAsyncInit = function fbAsyncInit() {
      window.FB.init({
        appId: `${import.meta.env.VITE_FACEBOOK_APP_ID}`,
        xfbml: true,
        version: 'v10.0',
      });

      // auto authenticate with the api if already logged in with facebook
      window.FB.getLoginStatus((response) => {
        statusChangeCallback(response);
      });
    };

    // load facebook sdk script
    (function sdk(d, s, id) {
      let js = d.getElementsByTagName(s)[0];
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
      js.onerror = scriptOnErroCallback
    }(document, 'script', 'facebook-jssdk'));
  });
}
